<div class="safety-widget mat-elevation-z2" animate.enter="widget-enter">
  <div class="widget-header" (click)="toggleExpand()">
    <div class="widget-title">
      <mat-icon>shield</mat-icon>
      @if (!isLoading && !hasError) {
        <span>{{ 'SAFETY_WIDGET.DAYS_SUMMARY' | translate:{count: daysWithoutEvent} }}</span>
      }
      @if (isLoading) {
        <span>{{ 'LOADING' | translate }}</span>
      }
      @if (hasError) {
        <span>{{ 'SAFETY_WIDGET.ERROR_SHORT' | translate }}</span>
      }
    </div>
    <button mat-icon-button class="expand-button" type="button">
      <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>

  @if (isExpanded) {
    <div class="widget-content-anim" animate.enter="expand-enter" animate.leave="expand-leave">
    <div class="widget-content">
      @if (isLoading) {
        <div class="loading">
          <mat-spinner diameter="24"></mat-spinner>
          <span>{{ 'LOADING' | translate }}</span>
        </div>
      }
      @if (hasError && !isLoading) {
        <div class="error">
          <mat-icon>error</mat-icon>
          <span>{{ 'SAFETY_WIDGET.ERROR_LOADING' | translate }}</span>
        </div>
      }
      @if (!isLoading && !hasError) {
        <div animate.enter="fade-in">
          <div class="stat" [ngClass]="getDaysClass()">
            <mat-icon class="xs-hidden">{{ getDaysIcon() }}</mat-icon>
            <span class="label">{{ 'DAYS_WITHOUT_EVENT' | translate }}:</span>
            <app-animated-number class="value" [number]="daysWithoutEvent" [decimals]="0"><span class="xs-hidden"> {{ 'SAFETY_WIDGET.DAY_ABBREVIATION' | translate }}</span></app-animated-number>
          </div>
          <ng-container *hasPermission="[permissions.SafetyEventsPermissions.CanViewEventFrequency]">
            <!-- Incidents and frequency both come from the /safety/frequency endpoint, which
            requires CanViewEventFrequency — gate both together so users without it don't see
            a misleading 0 (the endpoint 403s and the values never populate for them). -->
            <div class="stat" [ngClass]="getEventClass()">
              <mat-icon class="xs-hidden">{{ getEventIcon() }}</mat-icon>
              <span class="label">{{ 'SAFETY_WIDGET.INCIDENTS_LABEL' | translate }}:</span>
              <app-animated-number class="value" [number]="totalEvents" [decimals]="0"><span class="xs-hidden"> {{ 'SAFETY_WIDGET.UNITS_ABBREVIATION' | translate }}</span></app-animated-number>
            </div>
            <div class="stat" [ngClass]="getFrequencyClass()">
              <mat-icon class="xs-hidden">{{ getFrequencyIcon() }}</mat-icon>
              <span class="label">{{ 'SAFETY_WIDGET.FREQUENCY_LABEL' | translate }}:</span>
              <app-animated-number class="value" [number]="frequency" [decimals]="1" [forceDecimals]="true"> <span class="xs-hidden">{{ 'SAFETY_WIDGET.PER_MILLION_HOURS' | translate }}</span></app-animated-number>
            </div>
          </ng-container>
        </div>
      }
      @if (hasExtendedPermissions) {
        <mat-divider></mat-divider>
      }
      @if (!isLoading && !hasError && hasExtendedPermissions) {
        <div class="admin-controls">
          <button mat-stroked-button class="btn-primary" [routerLink]="['/safety']" *hasPermission="[permissions.SafetyEventsPermissions.CanSeeSafetyEventsReports]">{{ 'SAFETY_WIDGET.MORE_INFO' | translate }}</button>
          <button mat-stroked-button class="btn-primary" [routerLink]="['/safety','addevent']" *hasPermission="[permissions.SafetyEventsPermissions.CanAddSafetyEvents]">
            <mat-icon>add</mat-icon> {{'Add'|translate}}
          </button>
        </div>
      }
    </div>
    </div>
  }
</div>
